// src/constants/countries.ts

export const COUNTRIES: Array<{
  code: string;
  label: string;
  isDivider?: boolean;
}> = [
  { code: "", label: "" }, // Буде замінено динамічно
  { code: "de", label: "Deutschland" },
  { code: "pl", label: "Polen" },
  { code: "ua", label: "Ukraine" },
  { code: "hr", label: "Kroatien" },
  { code: "al", label: "Albanien" },
  { code: "ad", label: "Andorra" },
  { code: "at", label: "Österreich" },
  { code: "by", label: "Belarus" },
  { code: "be", label: "Belgien" },
  { code: "ba", label: "Bosnien und Herzegowina" },
  { code: "bg", label: "Bulgarien" },
  { code: "cy", label: "Zypern" },
  { code: "cz", label: "Tschechien" },
  { code: "dk", label: "Dänemark" },
  { code: "ee", label: "Estland" },
  { code: "fi", label: "Finnland" },
  { code: "fr", label: "Frankreich" },
  { code: "gr", label: "Griechenland" },
  { code: "hu", label: "Ungarn" },
  { code: "is", label: "Island" },
  { code: "ie", label: "Irland" },
  { code: "it", label: "Italien" },
  { code: "xk", label: "Kosovo" },
  { code: "lv", label: "Lettland" },
  { code: "li", label: "Liechtenstein" },
  { code: "lt", label: "Litauen" },
  { code: "lu", label: "Luxemburg" },
  { code: "mt", label: "Malta" },
  { code: "md", label: "Moldau" },
  { code: "mc", label: "Monaco" },
  { code: "me", label: "Montenegro" },
  { code: "nl", label: "Niederlande" },
  { code: "mk", label: "Nordmazedonien" },
  { code: "no", label: "Norwegen" },
  { code: "pt", label: "Portugal" },
  { code: "ro", label: "Rumänien" },
  { code: "ru", label: "Russland" },
  { code: "sm", label: "San Marino" },
  { code: "rs", label: "Serbien" },
  { code: "sk", label: "Slowakei" },
  { code: "si", label: "Slowenien" },
  { code: "es", label: "Spanien" },
  { code: "se", label: "Schweden" },
  { code: "ch", label: "Schweiz" },
  { code: "tr", label: "Türkei" },
  { code: "gb", label: "Vereinigtes Königreich" },
  { code: "va", label: "Vatikanstadt" },
  { code: "n_a", label: "Keine Angabe" },
];

// Функція для отримання списку країн з локалізованим placeholder
export const getCountriesWithPlaceholder = (placeholder: string) => {
  return COUNTRIES.map((country, index) =>
    index === 0 ? { ...country, label: placeholder } : country
  );
};
